export const rubrosHistoricos70 = [
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2025trim1-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2025trim1-Art70.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2025trim2-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2025trim2-Art70.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2025trim3-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2025trim3-Art70.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2025trim4-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2025trim4-Art70.zip"
            }
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2024trim1-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2024trim1-Art70.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2024trim2-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2024trim2-Art70.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2024trim3-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2024trim3-Art70.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2024trim4-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2024trim4-Art70.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2023trim1-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2023trim1-Art70.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2023trim2-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2023trim2-Art70.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2023trim3-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2023trim3-Art70.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2023trim4-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2023trim4-Art70.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2022trim1-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2022trim1-Art70.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2022trim2-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2022trim2-Art70.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2022trim3-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2022trim3-Art70.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art70/hist/2022trim4-Art70.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/historico/2022trim4-Art70.zip"
            }
        ]
    }
]